import { useEffect, useRef, useState } from "react";

import styles from "./Menu.module.css";

import Flyout from "../Flyout";

export function Option({children, onClick}) {
  return <div className={styles.option} onClick={onClick}>{children}</div>;
}

export default function Menu({button, children}) {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const buttonRef = useRef<HTMLDivElement>();
  const flyoutRef = useRef<HTMLDivElement>();

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (!open) return;
      const outsideOfButton = buttonRef.current && !buttonRef.current.contains(e.target as Node)
      const outsideOfFlyout = flyoutRef.current && !flyoutRef.current.contains(e.target as Node)
      if (outsideOfButton && outsideOfFlyout) {
        setClosing(true);
      }
    };

    if (flyoutRef.current) {
      flyoutRef.current.addEventListener("animationend", () => {
        if (closing) {
          setOpen(false);
          setClosing(false);
        }
      });
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [buttonRef.current, flyoutRef.current, open, closing]);

  return (
    <div ref={buttonRef} style={{display: "flex", cursor: "pointer"}} onClick={() => open ? setClosing(true) : setOpen(true)}>
      {button}
      {open &&
        <Flyout ref={flyoutRef} matchWidth={false} anchor="right" className={`${styles.flyout} ${closing ? styles.closing : styles.visible}`}>
          {children}
        </Flyout>
      }
    </div>
  );
}
